import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { fetchProfile, fetchStoreHomeComponents } from "../apiservices/ApiService";

const Fsn0DefaultScreen = () => {
  const pageId = 1

  useEffect(() => {
    getProfile();
  }, [pageId]);

  const getProfile = async () => {
    try {
      // Pass pagination dynamically
      const data = await fetchStoreHomeComponents({ pageId });

    } catch (err) {
      console.log(err.message || "Failed to fetch profile");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#f9f9f9",
      }}
    >
      <Typography variant="h4" color="error">
        Something Went Wrong!
      </Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        The screen you are looking for is not available.
      </Typography>

    </Box>
  );
};

export default Fsn0DefaultScreen;